import metricsApi from '@api/apiMetrics';

const getNewCities = () =>
  metricsApi.get('object/list/short', { ...{ output_object_type: ['region'] } });

export const newCitiesApi = { getNewCities };
